import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface ContentTypeDistributionResponse {
  items: Array<Items>;
  total_count: number;
};

export interface Items {
  type: number;
  type_name: string;
  count: number;
  ratio: number;
};

export class ContentTypeItemsData {
  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;

  @Required("Type name cannot be empty")
  @IsString("Type name must be a string")
  typeName: string;

  @Required("Count cannot be empty")
  @IsNumber("Count must be a number")
  count: number;

  @Required("Ratio cannot be empty")
  @IsNumber("Ratio must be a number")
  ratio: number;
}

export class ContentTypeDistributionData {
  @Required("items cannot be empty")
  @IsArray("items must be an array")
  items: ContentTypeItemsData[];

  @Required("Total count cannot be empty")
  @IsNumber("Total count must be a number")
  totalCount: number;
}

const transformAndValidateAgent = (
  response: ContentTypeDistributionResponse
): ContentTypeDistributionData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ContentTypeDistributionData);
  } catch (error) {
    console.error("Agent User Content Type Distribution data validation failed:", error.message);
    throw error;
  }
};

/** 内容管理 - 内容类型分布 */
export const contentTypeDistribution = async ({
  recentDays,
  agentId,
}: {
  recentDays: number,
  agentId: string,
}): Promise<ContentTypeDistributionData> => {
  const response = await api.post<ContentTypeDistributionResponse>('/agent-v2/user-stats/content-type-distribution', {
    recent_days: recentDays,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
